import { useQuery } from '@tanstack/react-query';
import { purchaseAnalysisApi } from '../lib/api.js';
import { queryKeys } from '../lib/query-keys.js';

/**
 * @graph-stack ac-mens-hub
 * @graph-domain Finance
 * @graph-business 購入分析の日次データを取得する hook。期間指定で購入率・購入単価・購入着数・売上を取得。
 * @graph-connects purchaseAnalysisApi.getDaily [calls] 購入分析日次 API
 */
export function usePurchaseDaily(from?: string, to?: string) {
  return useQuery({
    queryKey: queryKeys.purchaseAnalysis.daily(from, to),
    queryFn: () => purchaseAnalysisApi.getDaily({ from, to }),
  });
}
